import { create } from 'zustand';
import { saveAs } from 'file-saver';
import { ApiUtils } from '@shared/utils';
import { LettersApi } from '@shared/api';

interface UseDownloadLetterStore {
  loadingIds: Set<string>;
  data: boolean;
  error: string | null;
  get: (id: string, name?: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadLetterStore = create<UseDownloadLetterStore>((set) => ({
  loadingIds: new Set<string>(),
  data: false,
  error: null,

  get: async (id, name, signal) => {
    try {
      set((state) => ({ loadingIds: new Set(state.loadingIds).add(id), data: false, error: null }));
      const result = await LettersApi.downloadLetter(id, signal);
      saveAs(result.data, name);
      set({ data: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error) });
    } finally {
      set((state) => {
        const loadingIds = new Set(state.loadingIds);
        loadingIds.delete(id);
        return { loadingIds };
      });
    }
  },

  clear: () => set({ loadingIds: new Set<string>(), data: false, error: null }),
}));
